
export const heroTranslations = {
  heroTitle: {
    fr: "Singularité.club",
    en: "Singularité.club"
  },
  heroSubtitle: {
    fr: "Rejoignez la Collective des faiseurs et faiseuses qui explorent la frontière de l’innovation.",
    en: "Join the Collective of doers exploring the edge of innovation."
  },
  heroMotto: {
    fr: "Avançons ensemble, à la Singularité !",
    en: "Let’s move forward, together, at Singularité!"
  },
  joinButton: {
    fr: "Demander à rejoindre",
    en: "Request to join"
  },
  discover: {
    fr: "Découvrir",
    en: "Discover"
  },
};
